if (typeof com == 'undefined') window.com = {};
if (typeof com.openlane == 'undefined') window.com.openlane = {};
if (typeof com.openlane.utilities == 'undefined') window.com.openlane.utilities = {};

export function addWindowOnLoad(onloadFunction) {
    if (window.addEventListener) {
        window.addEventListener('load', onloadFunction, false);
    } else if (window.attachEvent) {
        window.attachEvent('onload', onloadFunction);
    }
}

export function formatCurrency(num) {
    return formatCurrencyCentsOptional(num, true);
}

export function isaNumber(text) {
    return !isNaN(text);
}

export function formatCurrencyCentsOptional(num, showCents) {
    return formatCurrencyForEnglish(num, showCents);
}

export function formatCurrencyForEnglish(num, showCents) {
    return formatCurrencyCentsWithOptions(num, showCents, com.openlane.utilities.currency.English);
}

export function formatCurrencyForFrench(num, showCents) {
    return formatCurrencyCentsWithOptions(num, showCents, com.openlane.utilities.currency.French);
}

export function formatCurrencyWithLocle(num, showCents, locale) {
    return formatCurrencyCentsWithOptions(num, showCents, locale);
}

if (typeof com.openlane.utilities.currencyLocation == 'undefined') com.openlane.utilities.currencyLocation = {
    Prefix: 0,
    Postfix: 1,
    Infix: 2
};

if (typeof com.openlane.utilities.currency == 'undefined') com.openlane.utilities.currency = {
    English: {
        GroupingSeparatorString: ",",
        SignString: "$",
        SignLocation: com.openlane.utilities.currencyLocation.Prefix
    },
    French: {
        GroupingSeparatorString: ".",
        SignString: "$",
        SignLocation: com.openlane.utilities.currencyLocation.Postfix
    }
};

if (typeof com.openlane.utilities.defaultCurrency == 'undefined') com.openlane.utilities.defaultCurrency = com.openlane.utilities.currency.English;

export function formatCurrencyCentsWithOptions(num, showCents, currentCurrency) {
    if (isNaN(num)) {
        return "";
    }

    var strParttern = "\\" + currentCurrency.SignString + "|\\" + currentCurrency.GroupingSeparatorString;
    num = num.toString().replace(new RegExp(strParttern, "g"), '');

    var sign = (num == (num = Math.abs(num)));
    num = Math.floor(num * 100 + 0.50000000001);
    var cents = num % 100;
    num = Math.floor(num / 100).toString();
    if (cents < 10)
        cents = "0" + cents;
    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
        num = num.substring(0, num.length - (4 * i + 3)) + currentCurrency.GroupingSeparatorString
            + num.substring(num.length - (4 * i + 3));

    var dollarAmount = num;
    if (currentCurrency.SignLocation == com.openlane.utilities.currencyLocation.Postfix) {
        dollarAmount = dollarAmount + currentCurrency.SignString;
    } else {
        dollarAmount = currentCurrency.SignString + dollarAmount;
    }
    dollarAmount = ((sign) ? '' : '-') + dollarAmount;

    if (showCents) dollarAmount = dollarAmount + '.' + cents;
    return dollarAmount;
}

if (typeof String.prototype.splice !== 'function') {
    String.prototype.splice = function (idx, rem, s) {
        return (this.slice(0, idx) + s + this.slice(idx + Math.abs(rem)));
    };
}

if (typeof String.prototype.trim !== 'function') {
    String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g, "");
    }
}

if (typeof String.prototype.parseInteger !== 'function') {
    String.prototype.parseInteger = function () {
        var number = this.replace(",", "");
        number = parseInt(number);
        return number;
    }
}


if (typeof String.prototype.endsWith !== 'function') {
    String.prototype.endsWith = function (str) {
        if (isUndefinedOrNull(this) || isUndefinedOrNull(str)) return false;
        return this.lastIndexOf(str) >= 0 && this.lastIndexOf(str) == (this.length - str.length);
    }
}

if (typeof String.prototype.startsWith !== 'function') {
    String.prototype.startsWith = function (str) {
        if (isUndefinedOrNull(this) || isUndefinedOrNull(str)) return false;
        return this.lastIndexOf(str) == 0;
    }
}

if (typeof String.prototype.equalsIgnoreCase !== 'function') {
    String.prototype.equalsIgnoreCase = function (str) {
        if (isUndefinedOrNull(this)) return isUndefinedOrNull(str);
        else if (!isUndefinedOrNull(str)) return str.toLowerCase() == this.toLowerCase();
        else return false;
    }
}
if (!('contains' in String.prototype)) {
    String.prototype.contains = function (str, startIndex) {
        return -1 !== String.prototype.indexOf.call(this, str, startIndex);
    };
}

export function isEmptyString(s) {
    return (!s || s.length === 0);
}

export function isUndefinedOrNull(obj) {
    return !angular.isDefined(obj);
}

export function isArray(obj) {
    //returns true is it is an array
    if ((isUndefinedOrNull(obj) || obj == null) || (obj.constructor.toString().indexOf("Array") == -1)) return false;
    else
        return true;
}

export function delayLoadImageSrc() {
    var imgs = document.getElementsByTagName('img');
    if (imgs) {
        for (var i = 0; tag = imgs[i]; i++) {
            var url = tag.getAttribute('delayload-src');
            if (url) tag.src = url;
        }
    }
}

if (typeof com.openlane.utilities.numberLocale == 'undefined') com.openlane.utilities.numberLocale = {
    English: {
        DecimalSeparatorSymbol: ".",
        GroupingSeparatorSymbol: ",",
        GroupingDigitSize: 3
    },
    French: {
        DecimalSeparatorSymbol: ".",
        GroupingSeparatorSymbol: " ",
        GroupingDigitSize: 3
    }
};

export function formatNumber(nStr) {
    return formatNumberForEnglish(nStr);
}

export function formatNumberForEnglish(nStr) {
    return formatNumberWithLocale(nStr, com.openlane.utilities.numberLocale.English);
}

export function formatNumberForFrench(nStr) {
    return formatNumberWithLocale(nStr, com.openlane.utilities.numberLocale.French);
}

export function formatNumberWithLocale(nStr, locale) {
    nStr += '';
    var x = nStr.split(locale.DecimalSeparatorSymbol);
    var x1 = x[0];
    var x2 = x.length > 1 ? locale.DecimalSeparatorSymbol + x[1] : '';
    var rgx = new RegExp("(\\d+)(\\d{" + locale.GroupingDigitSize + "})");
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + locale.GroupingSeparatorSymbol + '$2');
    }
    return x1 + x2;
}

String.prototype.startsWith = function (prefix) {
    return this.indexOf(prefix) === 0;
};

String.prototype.endsWith = function (suffix) {
    return this.match(suffix + "$") == suffix;
};


if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (elt /*, from*/) {
        var len = this.length;

        var from = Number(arguments[1]) || 0;
        from = (from < 0)
            ? Math.ceil(from)
            : Math.floor(from);
        if (from < 0)
            from += len;

        for (; from < len; from++) {
            if (from in this &&
                this[from] === elt)
                return from;
        }
        return -1;
    };
}


export function delayLoadImages() {
    setTimeout("delayLoadImageSrc()", 500);
}

export function delayLoadImagesAfterMS(ms) {
    setTimeout("delayLoadImageSrc()", ms);
}

RegExp.quote = function (str) {
    return str.replace(/(?=[\\^$*+?.()|{}[\]])/g, "\\");
};


export function closeDropdown() {
    //alert('hello');
    $('.top-bar-section').css('left', '0%');
    $('.top-bar').css('height', 'auto');
    $('.has-dropdown').removeClass('moved');
    $('.top-bar').data('index', 0);
}

export function toggleSearchMenu(action) {
    switch (action) {

        case 'open':
            if ($('#searchMenu').hasClass('active')) {
                $('#searchMenu').removeClass('active');
                $('.overlay').fadeOut();
            }
            else {
                $('#searchMenu').addClass('active');
                $('.overlay').fadeIn();
            }
            break;

        case 'close':
            $('#searchMenu').removeClass('active');
            $('.overlay').fadeOut();
            break;

    }
}

//detecting if its a mobile device
export const isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

export const replaceLocationName = [{nfrom: 'ADESA VANCOUVER', nto: 'ADESA Richmond Public Auction'}];



// WEBPACK FOOTER //
// ./resource/lib/utilities.js